// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UnsubscribeRouteImport } from './routes/unsubscribe'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as RequestAccessRouteImport } from './routes/request-access'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as MascotOptionsRouteImport } from './routes/mascot-options'
import { Route as LeaderboardRouteImport } from './routes/leaderboard'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as ActivateAccountRouteImport } from './routes/activate-account'
import { Route as ActivateRouteImport } from './routes/activate'
import { Route as AppRouteImport } from './routes/_app'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppUniverseRouteImport } from './routes/_app.universe'
import { Route as AppProfileRouteImport } from './routes/_app.profile'
import { Route as AppMyReportsRouteImport } from './routes/_app.my-reports'
import { Route as AppJoinLeagueRouteImport } from './routes/_app.join-league'
import { Route as AppHomeRouteImport } from './routes/_app.home'
import { Route as AppLeagueRouteImport } from './routes/_app.$league'
import { Route as PrintLeagueAllRouteImport } from './routes/print.$league.all'
import { Route as AppAdminIndexRouteImport } from './routes/_app.admin.index'
import { Route as AppAdminMembersRouteImport } from './routes/_app.admin.members'
import { Route as AppAdminCrossLeagueReportRouteImport } from './routes/_app.admin.cross-league-report'
import { Route as AppAdminBugsRouteImport } from './routes/_app.admin.bugs'
import { Route as AppAdminActivityRouteImport } from './routes/_app.admin.activity'
import { Route as AppLeagueIndexRouteImport } from './routes/_app.$league.index'
import { Route as AppLeagueScenariosRouteImport } from './routes/_app.$league.scenarios'
import { Route as AppLeagueGroupsRouteImport } from './routes/_app.$league.groups'
import { Route as AppLeagueCompareRouteImport } from './routes/_app.$league.compare'
import { Route as AppLeagueBracketRouteImport } from './routes/_app.$league.bracket'
import { Route as AppLeagueActivityRouteImport } from './routes/_app.$league.activity'
import { Route as PrintLeagueBracketBracketIdRouteImport } from './routes/print.$league.bracket.$bracketId'
import { Route as AppAdminTournamentsTournamentTypeRouteImport } from './routes/_app.admin.tournaments.$tournamentType'
import { Route as AppAdminLeaguesLeagueIdRouteImport } from './routes/_app.admin.leagues.$leagueId'
import { Route as AppLeagueMembersEntryIdRouteImport } from './routes/_app.$league.members.$entryId'
import { Route as AppLeagueEntriesNewRouteImport } from './routes/_app.$league.entries.new'
import { Route as AppLeagueScenariosScenarioIdRouteImport } from './routes/_app.$league.scenarios.$scenarioId'
import { Route as AppLeagueEntriesEntryIdEditRouteImport } from './routes/_app.$league.entries.$entryId.edit'

const UnsubscribeRoute = UnsubscribeRouteImport.update({
            id: '/unsubscribe',path: '/unsubscribe',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const RequestAccessRoute = RequestAccessRouteImport.update({
            id: '/request-access',path: '/request-access',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const MascotOptionsRoute = MascotOptionsRouteImport.update({
            id: '/mascot-options',path: '/mascot-options',getParentRoute: () => rootRouteImport
          })
const LeaderboardRoute = LeaderboardRouteImport.update({
            id: '/leaderboard',path: '/leaderboard',getParentRoute: () => rootRouteImport
          })
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
            id: '/forgot-password',path: '/forgot-password',getParentRoute: () => rootRouteImport
          })
const ActivateAccountRoute = ActivateAccountRouteImport.update({
            id: '/activate-account',path: '/activate-account',getParentRoute: () => rootRouteImport
          })
const ActivateRoute = ActivateRouteImport.update({
            id: '/activate',path: '/activate',getParentRoute: () => rootRouteImport
          })
const AppRoute = AppRouteImport.update({
            id: '/_app',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AppUniverseRoute = AppUniverseRouteImport.update({
            id: '/universe',path: '/universe',getParentRoute: () => AppRoute
          })
const AppProfileRoute = AppProfileRouteImport.update({
            id: '/profile',path: '/profile',getParentRoute: () => AppRoute
          })
const AppMyReportsRoute = AppMyReportsRouteImport.update({
            id: '/my-reports',path: '/my-reports',getParentRoute: () => AppRoute
          })
const AppJoinLeagueRoute = AppJoinLeagueRouteImport.update({
            id: '/join-league',path: '/join-league',getParentRoute: () => AppRoute
          })
const AppHomeRoute = AppHomeRouteImport.update({
            id: '/home',path: '/home',getParentRoute: () => AppRoute
          })
const AppLeagueRoute = AppLeagueRouteImport.update({
            id: '/$league',path: '/$league',getParentRoute: () => AppRoute
          })
const PrintLeagueAllRoute = PrintLeagueAllRouteImport.update({
            id: '/print/$league/all',path: '/print/$league/all',getParentRoute: () => rootRouteImport
          })
const AppAdminIndexRoute = AppAdminIndexRouteImport.update({
            id: '/admin/',path: '/admin/',getParentRoute: () => AppRoute
          })
const AppAdminMembersRoute = AppAdminMembersRouteImport.update({
            id: '/admin/members',path: '/admin/members',getParentRoute: () => AppRoute
          })
const AppAdminCrossLeagueReportRoute = AppAdminCrossLeagueReportRouteImport.update({
            id: '/admin/cross-league-report',path: '/admin/cross-league-report',getParentRoute: () => AppRoute
          })
const AppAdminBugsRoute = AppAdminBugsRouteImport.update({
            id: '/admin/bugs',path: '/admin/bugs',getParentRoute: () => AppRoute
          })
const AppAdminActivityRoute = AppAdminActivityRouteImport.update({
            id: '/admin/activity',path: '/admin/activity',getParentRoute: () => AppRoute
          })
const AppLeagueIndexRoute = AppLeagueIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppLeagueRoute
          })
const AppLeagueScenariosRoute = AppLeagueScenariosRouteImport.update({
            id: '/scenarios',path: '/scenarios',getParentRoute: () => AppLeagueRoute
          })
const AppLeagueGroupsRoute = AppLeagueGroupsRouteImport.update({
            id: '/groups',path: '/groups',getParentRoute: () => AppLeagueRoute
          })
const AppLeagueCompareRoute = AppLeagueCompareRouteImport.update({
            id: '/compare',path: '/compare',getParentRoute: () => AppLeagueRoute
          })
const AppLeagueBracketRoute = AppLeagueBracketRouteImport.update({
            id: '/bracket',path: '/bracket',getParentRoute: () => AppLeagueRoute
          })
const AppLeagueActivityRoute = AppLeagueActivityRouteImport.update({
            id: '/activity',path: '/activity',getParentRoute: () => AppLeagueRoute
          })
const PrintLeagueBracketBracketIdRoute = PrintLeagueBracketBracketIdRouteImport.update({
            id: '/print/$league/bracket/$bracketId',path: '/print/$league/bracket/$bracketId',getParentRoute: () => rootRouteImport
          })
const AppAdminTournamentsTournamentTypeRoute = AppAdminTournamentsTournamentTypeRouteImport.update({
            id: '/admin/tournaments/$tournamentType',path: '/admin/tournaments/$tournamentType',getParentRoute: () => AppRoute
          })
const AppAdminLeaguesLeagueIdRoute = AppAdminLeaguesLeagueIdRouteImport.update({
            id: '/admin/leagues/$leagueId',path: '/admin/leagues/$leagueId',getParentRoute: () => AppRoute
          })
const AppLeagueMembersEntryIdRoute = AppLeagueMembersEntryIdRouteImport.update({
            id: '/members/$entryId',path: '/members/$entryId',getParentRoute: () => AppLeagueRoute
          })
const AppLeagueEntriesNewRoute = AppLeagueEntriesNewRouteImport.update({
            id: '/entries/new',path: '/entries/new',getParentRoute: () => AppLeagueRoute
          })
const AppLeagueScenariosScenarioIdRoute = AppLeagueScenariosScenarioIdRouteImport.update({
            id: '/$scenarioId',path: '/$scenarioId',getParentRoute: () => AppLeagueScenariosRoute
          })
const AppLeagueEntriesEntryIdEditRoute = AppLeagueEntriesEntryIdEditRouteImport.update({
            id: '/entries/$entryId/edit',path: '/entries/$entryId/edit',getParentRoute: () => AppLeagueRoute
          })





const AppLeagueScenariosRouteChildren = {
  AppLeagueScenariosScenarioIdRoute: AppLeagueScenariosScenarioIdRoute
}

const AppLeagueScenariosRouteWithChildren = AppLeagueScenariosRoute._addFileChildren(AppLeagueScenariosRouteChildren)



const AppLeagueRouteChildren = {
  AppLeagueActivityRoute: AppLeagueActivityRoute,AppLeagueBracketRoute: AppLeagueBracketRoute,AppLeagueCompareRoute: AppLeagueCompareRoute,AppLeagueGroupsRoute: AppLeagueGroupsRoute,AppLeagueScenariosRoute: AppLeagueScenariosRouteWithChildren,AppLeagueIndexRoute: AppLeagueIndexRoute,AppLeagueEntriesNewRoute: AppLeagueEntriesNewRoute,AppLeagueMembersEntryIdRoute: AppLeagueMembersEntryIdRoute,AppLeagueEntriesEntryIdEditRoute: AppLeagueEntriesEntryIdEditRoute
}

const AppLeagueRouteWithChildren = AppLeagueRoute._addFileChildren(AppLeagueRouteChildren)



const AppRouteChildren = {
  AppLeagueRoute: AppLeagueRouteWithChildren,AppHomeRoute: AppHomeRoute,AppJoinLeagueRoute: AppJoinLeagueRoute,AppMyReportsRoute: AppMyReportsRoute,AppProfileRoute: AppProfileRoute,AppUniverseRoute: AppUniverseRoute,AppAdminActivityRoute: AppAdminActivityRoute,AppAdminBugsRoute: AppAdminBugsRoute,AppAdminCrossLeagueReportRoute: AppAdminCrossLeagueReportRoute,AppAdminMembersRoute: AppAdminMembersRoute,AppAdminIndexRoute: AppAdminIndexRoute,AppAdminLeaguesLeagueIdRoute: AppAdminLeaguesLeagueIdRoute,AppAdminTournamentsTournamentTypeRoute: AppAdminTournamentsTournamentTypeRoute
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AppRoute: AppRouteWithChildren,ActivateRoute: ActivateRoute,ActivateAccountRoute: ActivateAccountRoute,ForgotPasswordRoute: ForgotPasswordRoute,LeaderboardRoute: LeaderboardRoute,MascotOptionsRoute: MascotOptionsRoute,PrivacyRoute: PrivacyRoute,RequestAccessRoute: RequestAccessRoute,ResetPasswordRoute: ResetPasswordRoute,UnsubscribeRoute: UnsubscribeRoute,PrintLeagueAllRoute: PrintLeagueAllRoute,PrintLeagueBracketBracketIdRoute: PrintLeagueBracketBracketIdRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)